import { ACCESS_LEVELS, FEATURE_FLAGS } from '@/lib/consts.ts'

import { __t } from '@/lib/helpers'
import { ROUTE_META_PARAMS } from '@/router/consts.ts'
import { useEppo } from '@/composables/eppo'
import { store } from '@/store/index.js'

const shouldBeVisible = (store) => {
  const isFrenchCertificationEnabled = store.getters['business/isFrenchCertificationEnabled']
  return !isFrenchCertificationEnabled
}

/** Voucher sub-routes require config; when only loyalty is enabled, keep users on the hub. */
const beforeEnterVoucherSubroutes = (_to, _from, next) => {
  if (store.state.routingConfig?.config?.vouchers_enabled) {
    next()
    return
  }
  if (useEppo().ff(FEATURE_FLAGS.LoyaltyProgram)) {
    next({ name: 'gifts-and-bundle-services', replace: true })
    return
  }
  next()
}

export default {
  path: 'gifts-and-bundle-services',
  name: 'gifts-and-bundle-services',
  meta: {
    [ROUTE_META_PARAMS.ACCESS_LEVEL]: ACCESS_LEVELS.ADVANCED,
  },
  component: () => import('@/views/business/gifts-and-bundle-services/index.vue'),
  children: [
    {
      path: 'gift-cards',
      name: 'gift-cards',
      beforeEnter: beforeEnterVoucherSubroutes,
      meta: {
        title: __t('routes.gifts.gift-cards.title'),
        subtitle: __t('routes.gifts.gift-cards.subtitle'),
        hintKey: 'hintFeatureGiftCards',
      },
      component: () => import('@/views/business/gifts-and-bundle-services/gifts-route.vue'),
    },
    {
      path: 'memberships',
      name: 'memberships',
      beforeEnter: beforeEnterVoucherSubroutes,
      meta: {
        title: __t('routes.gifts.memberships.title'),
        subtitle: __t('routes.gifts.memberships.subtitle'),
        hintKey: 'hintFeatureMemberships',
        [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: shouldBeVisible,
      },
      component: () => import('@/views/business/gifts-and-bundle-services/gifts-route.vue'),
    },
    {
      path: 'packages',
      name: 'packages',
      beforeEnter: beforeEnterVoucherSubroutes,
      meta: {
        title: __t('routes.gifts.packages.title'),
        subtitle: __t('routes.gifts.packages.subtitle'),
        hintKey: 'hintFeaturePackages',
        [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: shouldBeVisible,
      },
      component: () => import('@/views/business/gifts-and-bundle-services/gifts-route.vue'),
    },
  ],
}
